import { render, staticRenderFns } from "./FlexCard.vue?vue&type=template&id=e7285226&"
import script from "./FlexCard.vue?vue&type=script&lang=js&"
export * from "./FlexCard.vue?vue&type=script&lang=js&"
import style0 from "./FlexCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports